import { render, staticRenderFns } from "./modal-membership-types-create-year.vue?vue&type=template&id=8ded5b3a&scoped=true"
import script from "./modal-membership-types-create-year.vue?vue&type=script&lang=js"
export * from "./modal-membership-types-create-year.vue?vue&type=script&lang=js"
import style0 from "./modal-membership-types-create-year.vue?vue&type=style&index=0&id=8ded5b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded5b3a",
  null
  
)

export default component.exports